import { ITheme } from "survey-core";
import { baseThemeJson } from "./baseTheme";

export const themeJson: ITheme = {
    ...baseThemeJson,
    cssVariables: {
        ...baseThemeJson.cssVariables,
        "--sjs-primary-backcolor": "#5472CC",
    },
};
